<template>
  <div>
    <div class="ivu-select-selection p-5" style="position: relative; display: flow-root;">
      <svg style="position: absolute; top: 25px; left: 10px;" viewBox="0 0 1024 1024" width="20" height="20"><path d="M621.713502 512.003657A255.998171 255.998171 0 1 1 877.711673 256.371197 255.998171 255.998171 0 0 1 621.713502 512.003657z" fill="#D5F7F5" p-id="2759"></path><path d="M514.19427 1020.56231a63.414404 63.414404 0 0 1-45.201963-19.236434c-9.581646-10.166785-96.840451-101.960415-183.58726-218.622438C168.743023 625.447418 109.42459 500.739738 109.42459 410.920951A405.208534 405.208534 0 0 1 514.121128 6.15127a405.208534 405.208534 0 0 1 404.76968 404.769681c0 54.271612-20.772423 120.684852-61.878415 197.338019-40.081999 74.605181-99.912429 160.766852-178.028443 256.656452l-0.511996 0.511996-116.662024 133.850473a61.073849 61.073849 0 0 1-46.079671 21.284419h-1.609131z m0-958.603438a348.742652 348.742652 0 0 0-348.523225 348.450082c0 76.068028 56.831594 193.242048 164.862823 338.356441 86.307955 116.150027 175.541603 209.479647 179.052435 213.575617a7.53366 7.53366 0 0 0 4.534825 1.974843h0.511996c1.535989 0 3.071978-1.023993 4.095971-2.047985l116.662024-133.411619c76.068028-93.329619 133.850472-176.492454 171.884486-247.513661 37.083164-68.461225 55.368747-126.316812 55.368748-170.933636A349.035221 349.035221 0 0 0 514.121128 61.958872z" fill="#000000"></path></svg>
        <div v-if="addressData[titleKey]" style="float: left; padding: 5px; padding-left: 40px; min-height: 60px; line-height: 28px; width: 100%;">
        <a @click="addressListDrawer = true" style="float: right;">选择其他地址 ></a>
        <strong style="font-size: 16px;">{{ addressData['收货人姓名'] }}</strong>
        <small>{{ addressData['收货人电话'] }}</small><br />
        {{ addressData['收货市'] }}{{ addressData['收货城'] }}{{ addressData['收货区'] }}{{ addressData['收货详情'] }}
      </div>
      <div @click="addressListDrawer = true" v-else style="float: left; padding: 5px; padding-left: 40px; height: 60px; line-height: 50px; width: 100%;">
        <a>选择收货地址 ></a>
      </div>
    </div>
    <van-popup v-model="addressListDrawer" round position="bottom" :style="{ height: '70%' }" class="address-list-drawer">
      <van-nav-bar :title="addressListDrawerTitle" :left-text="isEdutAddress ? '返回' : ''" :left-arrow="isEdutAddress" @click-left="onClickLeft" />
      <Spin v-show="loading" fix size="large"></Spin>
      <div :style="'position: relative; height: ' + popupBodyHeight + 'px;'">
        <van-address-edit
          v-if="isEdutAddress"
          :address-info="addressInfo"
          :area-list="areaList"
          show-postal
          :show-delete="addressInfo.id ? true :false"
          show-search-result
          :area-columns-placeholder="['请选择', '请选择', '请选择']"
          :area-value="'110101'"
          @save="onSave"
          @delete="onDelete"
        />
        <van-address-list v-else v-model="chosenAddressId" :list="list" @add="onAdd" @edit="onEdit" @select="onSelect"/>
      </div>
    </van-popup>
    <!-- <Drawer class="address-list-drawer" placement="bottom" :closable="false" :height="drawerHeight" v-model="addressListDrawer">
    </Drawer> -->
  </div>
</template>
<script>
import { Toast } from 'vant'
import { areaList } from '@vant/area-data'

export default {
  name: 'SelectAddress',
  components: {
  },
  props: {
    idx: {
      type: Number
    },
    projectId: {
      type: String
    },
    apiroot: {
      type: String
    },
    member: {
      type: Object
    },
    addressData: {
      type: Object
    },
    titleKey: {
      type: String
    },
    onChange: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      addressListDrawer: false,
      addressListDrawerTitle: '',
      isEdutAddress: false,
      addressInfo: {},
      popupBodyHeight: window.innerHeight * 0.7 - 50,
      chosenAddressId: 0,
      list: [],
      areaList: areaList
    }
  },
  watch: {
    'addressListDrawer': function () {
      if (this.addressListDrawer) {
        if (this.list.length === 0) {
          this.loading = true
        }
        this.getAddressList()
        this.addressListDrawerTitle = '请选择地址'
      }
    },
    'chosenAddressId': function () {
      this.addressListDrawer = false
      this.chosenAddress()
    },
    'addressData': function () {
      this.getAddressList(true)
    }
  },
  methods: {
    chosenAddress () {
      for (var idx in this.list) {
        if (this.chosenAddressId === this.list[idx].id) {
          this.$set(this.addressData, this.titleKey, this.chosenAddressId)
          this.$set(this.addressData, '收货人姓名', this.list[idx].name)
          this.$set(this.addressData, '收货人电话', this.list[idx].tel)
          this.$set(this.addressData, '收货市', this.list[idx].province)
          this.$set(this.addressData, '收货城', this.list[idx].city)
          this.$set(this.addressData, '收货区', this.list[idx].county)
          this.$set(this.addressData, '收货详情', this.list[idx].address_detail)
          this.$set(this.addressData, '邮政编码', this.list[idx].postal_code)
          this.$props.onChange(this.idx)
        }
      }
    },
    onClickLeft () {
      this.isEdutAddress = false
      this.addressListDrawerTitle = '请选择地址'
    },
    onSave (data) {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '保存中...'
      })
      var postData = {}
      postData['sign'] = 'common'
      postData['action'] = data.id ? 'editAddress' : 'addAddress'
      postData['project_id'] = this.projectId
      postData['data'] = data
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        Toast.clear()
        if (response.data.code === 1) {
          Toast.success('保存成功')
          this.onClickLeft()
          this.getAddressList()
        } else {
          Toast.success('保存失败' + (response.data.message ? '，' + response.data.message + '。' : '。'))
        }
      })
    },
    onDelete (data) {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '保存中'
      })
      var postData = {}
      postData['sign'] = 'common'
      postData['action'] = 'deleteAddress'
      postData['project_id'] = this.projectId
      postData['data'] = data
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        Toast.clear()
        if (response.data.code === 1) {
          Toast.success('删除成功')
          this.onClickLeft()
          this.getAddressList()
        } else {
          Toast.fail('删除失败' + (response.data.message ? '，' + response.data.message + '。' : '。'))
        }
      })
    },
    getAddressList (isReset) {
      var postData = {}
      postData['sign'] = 'common'
      postData['action'] = 'getAddress'
      postData['project_id'] = this.projectId
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        this.loading = false
        if (response.data.code === 1) {
          for (var idx in response.data.data) {
            response.data.data[idx].address = response.data.data[idx].province
            if (response.data.data[idx].province !== response.data.data[idx].city) {
              response.data.data[idx].address += response.data.data[idx].city
            }
            response.data.data[idx].address += response.data.data[idx].county + response.data.data[idx].address_detail
          }
          this.$set(this, 'list', response.data.data)
          if (isReset) {
            for (var _idx in this.list) {
              if (this.list[_idx].name === this.addressData['收货人姓名'] && this.list[_idx].tel === this.addressData['收货人电话'] && this.list[_idx].province === this.addressData['收货市'] && this.list[_idx].city === this.addressData['收货城'] && this.list[_idx].county === this.addressData['收货区'] && this.list[_idx].address_detail === this.addressData['收货详情'] && this.list[_idx].postal_code === this.addressData['邮政编码']) {
                this.addressData[this.titleKey] = this.list[_idx].id
              }
            }
          }
        }
      })
    },
    onAdd () {
      this.isEdutAddress = true
      this.$set(this, 'addressInfo', {})
      this.addressListDrawerTitle = '新增地址'
    },
    onEdit (data) {
      data.addressDetail = data.address_detail
      data.areaCode = data.area_code
      data.postalCode = data.postal_code
      this.$set(this, 'addressInfo', data)
      this.isEdutAddress = true
      this.addressListDrawerTitle = '编辑地址'
    },
    onSelect (data) {
      this.chosenAddressId = data.id
      this.addressListDrawer = false
      this.chosenAddress()
    }
  },
  mounted () {
  }
}
</script>
<style>
.address-list-drawer .ivu-drawer-body { padding: 5px; }
.address-list-drawer .van-address-item { border: 1px solid #fff; }
.address-list-drawer .van-address-item:hover { border: 1px solid #dcdee2; }
</style>



// WEBPACK FOOTER //
// src/components/member-address/selectAddress.vue